import gql from 'graphql-tag';

export default gql`
fragment PaymentMethodAllFragment on PaymentMethod {
    id
    name
    is_active
    code
    sort
    short_description
    short_description_mpl_type
    cost
}
`;


// WEBPACK FOOTER //
// ./src/api/graphql/fragments/PaymentMethodAllFragment.ts